/**
 Set following line to true when deploying to LIVE Environment
*/
import * as firebase from 'firebase';

// Firebase project configuration params DEVELOPMENT
const firebaseConfig = {
	apiKey: "AIzaSyCOVnMGa59nWGUHeZvSX7Q0HTsG3kMiWpE",
	authDomain: "dogmoticswebapp.firebaseapp.com",
	databaseURL: "https://dogmoticswebapp.firebaseio.com",
	projectId: "dogmoticswebapp",
	storageBucket: "dogmoticswebapp.appspot.com",
	messagingSenderId: "244611063061",
	appId: "1:244611063061:web:a8c1ab14c4e07673f49d1c", //dogmotics_admin
};

// Firebase project configuration params LIVE
/*const firebaseConfig = {
	apiKey: "",
	authDomain: "dogmoticswebapp.firebaseapp.com",
	databaseURL: "https://dogmoticswebapp.firebaseio.com",
	projectId: "dogmoticswebapp",
	storageBucket: "dogmoticswebapp.appspot.com",
	messagingSenderId: "244611063061",
	appId: "1:244611063061:web:a8c1ab14c4e07673f49d1c",
};*/
// Replace with your cloud functions location
//const functionLocation = 'europe-west3';

const firebaseApp = firebase.initializeApp(firebaseConfig);

const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();
const functions = firebaseApp.functions();

/*// Store defaults
// STORE=DM001 - DogMotics1 by Amici di TOBIA - via Sardegna 35 - Milano
const storeDefaults = {
	code: "DM001",
	phonePrefix: "+39",
	city: "Milano",
	province: "MI",
	country: "IT",
	language: "it",
	currency: "eur"
}*/

export { firebaseApp, timestamp, db, auth, functions }